import { useMatches } from 'react-router';

import type { RootLoaderData } from '~/rootLoader';

export default function useRootData(): RootLoaderData {
  const matches = useMatches();
  const root = matches[0]!.data as RootLoaderData;

  if (root.session) return root;

  for (let i = matches.length - 1; i >= 1; i--) {
    const session = (matches[i]?.data as { session?: string } | undefined)
      ?.session;

    if (session) return { ...root, session };
  }

  return root;
}
